<form [formGroup]="parentForm">
    @if (!customFieldControlInfos || customFieldControlInfos.length === 0) {
        <div>
            {{ emptyMessage || ("cerrixCustomFieldsEditor.noCustomFieldsDefined" | transloco) }}
        </div>
    }
    @if (customFieldControlInfos) {
        <div formArrayName="customFields">
            <div class="row">
                @for (
                    customField of customFieldControlInfos;
                    track customField;
                    let customFieldIndex = $index
                ) {
                    <div
                        [formGroupName]="customFieldIndex"
                        class="form-group col-{{ columns }}  {{
                            !singleColumn
                                ? customFieldIndex % 2 == 0
                                    ? 'left-block'
                                    : 'right-block'
                                : ''
                        }}"
                    >
                        @if (
                            customField.data.fieldType !== CustomFieldType.Textfield &&
                            customField.data.fieldType !== CustomFieldType.Textarea
                        ) {
                            <label for="customFieldInput-{{ customField.id }}">{{
                                customField.data.Name
                            }}</label>
                        }
                        @switch (customField.data.fieldType) {
                            @case (CustomFieldType.Textfield) {
                                <cerrix-textfield
                                    [fieldLabel]="customField.data.Name"
                                    identifier="customFieldInput-{{ customField.id }}"
                                    formControlName="value"
                                    [placeholder]="customField.data.required ? 'Required' : ''"
                                ></cerrix-textfield>
                            }
                            @case (CustomFieldType.Textarea) {
                                <cerrix-textarea
                                    [fieldLabel]="customField.data.Name"
                                    identifier="customFieldInput-{{ customField.id }}"
                                    [rows]="9"
                                    formControlName="value"
                                    [placeholder]="customField.data.required ? 'Required' : ''"
                                ></cerrix-textarea>
                            }
                            @case (CustomFieldType.DateField) {
                                <date-input
                                    name="customFieldInput-{{ customField.id }}"
                                    formControlName="dateValue"
                                    [required]="customField.data.required"
                                    inputTooltip
                                ></date-input>
                            }
                            @case (CustomFieldType.NumberField) {
                                <input
                                    class="form-control form-control-sm"
                                    formControlName="value"
                                    type="number"
                                    name="customFieldInput-{{ customField.id }}"
                                    [required]="customField.data.required"
                                    [placeholder]="customField.data.required ? 'Required' : ''"
                                    inputTooltip
                                />
                            }
                            @case (CustomFieldType.SingleSelect) {
                                <ng-select
                                    [formControlName]="'optionId'"
                                    name="customFieldInput-{{ customField.id }}"
                                    [placeholder]="customField.data.required ? 'Required' : ''"
                                    [items]="customField.data.answerOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    inputTooltip
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <div
                                            [style.background-color]="item.Color"
                                            class="color-indicator"
                                        ></div>
                                        {{ item.Name }}
                                    </ng-template>
                                </ng-select>
                            }
                            @case (CustomFieldType.MultiSelect) {
                                <ng-select
                                    [formControlName]="'optionIds'"
                                    name="customFieldInput-{{ customField.id }}"
                                    [placeholder]="customField.data.required ? 'Required' : ''"
                                    [items]="customField.data.answerOptions"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    inputTooltip
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <div
                                            [style.background-color]="item.Color"
                                            class="color-indicator"
                                        ></div>
                                        {{ item.Name }}
                                    </ng-template>
                                </ng-select>
                            }
                        }
                    </div>
                }
            </div>
        </div>
    }
</form>
